export const sharedRecordCopy = {
  ko: {
    unavailableTitle: '이 기록을 열 수 없습니다.',
    unavailableHint: '링크가 만료됐거나 보호자가 공유를 중단했을 수 있습니다.',
    loadingTitle: '기록을 불러오는 중입니다.',
    petSwitcherLabel: '반려동물 선택',
    selectedPet: '현재 선택',
    guardianRecord: '보호자가 정리한 기록',
    readOnly: '읽기 전용 링크',
    cat: '고양이',
    pet: '반려동물',
    profileImage: '대표 사진',
    noProfileImage: '대표 사진이 없습니다',
    age: '나이',
    sex: '성별',
    adopted: '입양일',
    registration: '동물등록',
    unregistered: '미등록',
    currentNotes: '지금 전할 내용',
    currentNotesBody: '집에서 계속 보이는 변화를 적은 내용입니다.',
    noCurrentNotes: '현재 계속된다고 적은 증상은 없습니다.',
    scheduledVisit: '내원 예정',
    lastEdited: '마지막 수정',
    expires: '링크 만료',
    pageContents: '이 페이지에 담긴 내용',
    ongoingSymptoms: '계속 관찰되는 증상',
    questions: '병원에 물어볼 내용',
    attachments: '사진과 진료자료',
    timelineEyebrow: '날짜별 기록',
    timelineTitle: '처음 기록부터 차례대로',
    oldestDescription: '오래된 기록부터 보여줍니다.',
    newestDescription: '최근 기록부터 보여줍니다.',
    oldest: '오래된 순',
    newest: '최근 순',
    timelineEmpty: '공유된 기록이 없습니다.',
    guardianConcern: '보호자 걱정이 큰 기록',
    mediaHeading: '사진과 영상',
    mediaEmpty: '공유된 사진이나 영상이 없습니다.',
    documentsHeading: '이전 병원 진료자료',
    documentEmpty: '공유된 진료자료가 없습니다.',
    openFile: '파일 열기',
    fileUnavailable: '파일 없음',
    questionEmpty: '적어 둔 내용이 없습니다.',
    factsHeading: '평소 생활과 입양 당시 정보',
    initialCondition: '처음 만났을 때',
    usualFeeding: '평소 먹는 것',
    weight: '체중',
    disclaimerTitle: '보호자가 집에서 본 내용과 받은 자료를 정리한 페이지입니다.',
    disclaimerBody: '진단이나 처방을 요청하는 문서가 아닙니다. 진료에 필요한 판단은 담당 수의사에게 맡깁니다.',
  },
  en: {
    unavailableTitle: 'This record is unavailable.',
    unavailableHint: 'The link may have expired or the guardian may have stopped sharing it.',
    loadingTitle: 'Loading the record.',
    petSwitcherLabel: 'Choose a pet',
    selectedPet: 'Selected',
    guardianRecord: 'Notes prepared by the guardian',
    readOnly: 'Read-only link',
    cat: 'Cat',
    pet: 'Pet',
    profileImage: 'profile photo',
    noProfileImage: 'No profile photo',
    age: 'Age',
    sex: 'Sex',
    adopted: 'Adopted',
    registration: 'Registration',
    unregistered: 'Not registered',
    currentNotes: 'What to share today',
    currentNotesBody: 'Changes that are still being seen at home.',
    noCurrentNotes: 'No ongoing symptoms were noted.',
    scheduledVisit: 'Visit',
    lastEdited: 'Last edited',
    expires: 'Link expires',
    pageContents: 'Included in this page',
    ongoingSymptoms: 'Ongoing symptoms',
    questions: 'Questions for the clinic',
    attachments: 'Photos and clinic files',
    timelineEyebrow: 'Dated notes',
    timelineTitle: 'From the first note onward',
    oldestDescription: 'Oldest notes are shown first.',
    newestDescription: 'Newest notes are shown first.',
    oldest: 'Oldest first',
    newest: 'Newest first',
    timelineEmpty: 'No notes were shared.',
    guardianConcern: 'A record of greater concern to the guardian',
    mediaHeading: 'Photos and videos',
    mediaEmpty: 'No photos or videos were shared.',
    documentsHeading: 'Records from previous clinics',
    documentEmpty: 'No clinic files were shared.',
    openFile: 'Open file',
    fileUnavailable: 'No file',
    questionEmpty: 'No questions were added.',
    factsHeading: 'Background and everyday care',
    initialCondition: 'When first met',
    usualFeeding: 'Usual food',
    weight: 'Weight',
    disclaimerTitle: 'This page collects what the guardian saw at home and records they received.',
    disclaimerBody: 'It is not a request for a diagnosis or prescription. Clinical decisions remain with the attending veterinarian.',
  },
} as const

export type SharedRecordLocale = keyof typeof sharedRecordCopy
